module.exports = __webpack_public_path__ + "img/canada-ischemic-heart-disease-male.2bd8be41.png";